import { StepNoteId } from '../../BrandedIds';
import { Actor } from '../../events';
import { Temporal } from '../../Temporal';

export interface SerializedStepNote {
  id: StepNoteId;
  note: string;
  createdAt: Temporal.ZonedDateTimeLike | string;
  createdBy: Actor;
}

export interface StepNote extends SerializedStepNote {
  createdAt: Temporal.ZonedDateTime;
}

export function reviveStepNote(serialized: SerializedStepNote): StepNote {
  return {
    ...serialized,
    createdAt: Temporal.ZonedDateTime.from(serialized.createdAt),
  };
}
